import { faker } from "@faker-js/faker";
const generateRandomDate = () => {
  const startDate = new Date(2020, 0, 1);
  const endDate = new Date();
  return new Date(
    startDate.getTime() +
      Math.random() * (endDate.getTime() - startDate.getTime()),
  );
};

const generateRandomRole = () => {
  const roles = ["ADMIN", "MANAGER"];
  return roles[Math.floor(Math.random() * roles.length)];
};

const generateRandomStatus = () => {
  const statuses = ["active", "inviting", "inactive"];
  return statuses[Math.floor(Math.random() * statuses.length)];
};

const generateRandomUser = (id: number) => ({
  id: id,
  firstName: faker.person.firstName(),
  lastName: faker.person.lastName(),
  iGG: faker.number.int({ min: 100000, max: 999999 }).toString(),
  email: faker.internet.email(),
  role: generateRandomRole(),
  status: generateRandomStatus(),
  createdAt: faker.date.past().toISOString().slice(0, 10),
  lastConnection: generateRandomDate().toISOString().slice(0, 10),
});

export const generateUsers = (numUsers: number) => {
  const users = [];
  //ignore the fro loop rule
  // eslint-disable-next-line no-restricted-syntax
  for (let i = 1; i <= numUsers; i++) {
    users.push(generateRandomUser(i));
  }
  return users;
};
